// polyfills need to be at the top
import 'polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import { Root } from './Root';

// import i18n (needs to be bundled)
import './i18n';

ReactDOM.render(<Root />, document.getElementById('root'));
